import { RouteRecordRaw } from "vue-router";

export const authRoutes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "Login",
    component: () => import("./views/LoginView.vue"),
    meta: { title: "Iniciar Sesión", guestOnly: true },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("./views/RegisterView.vue"),
    meta: { title: "Registrarse", guestOnly: true },
  },
];
